let nativeRTCSessionDescription =
    window.RTCSessionDescription || window.mozRTCSessionDescription || window.webkitRTCSessionDescription;

let PeerConnection =
    window.RTCPeerConnection ||
    window.mozRTCPeerConnection ||
    window.webkitRTCPeerConnection ||
    window.PeerConnection ||
    window.webkitPeerConnection00;

let nativeRTCIceCandidate = window.RTCIceCandidate || window.mozRTCIceCandidate || window.webkitRTCSessionDescription;

export { nativeRTCSessionDescription, PeerConnection, nativeRTCIceCandidate };



// WEBPACK FOOTER //
// ./components/f.component.mediasource/app/modules/adapter.js